export default __webpack_public_path__ + "static/media/11_LeftToRightSquares_Flip.8f48d48c.mp4";